import React from 'react';
import { Redirect } from 'react-router-dom';
import { doDemoModeOnOff } from '../../helpers';
export function DemoOffPage() {
  doDemoModeOnOff();
  return (
    <>
      <Redirect
        exact
        from="/"
        to="/dashboard"
      />
    </>
  );
}
